import React, { useEffect } from "react";

function CommuteDetailModal({ date, data, onClose }) {

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const weekday = weekdays[d.getDay()];
    return `${year}년 ${month}월 ${day}일 (${weekday})`;
  };

  return (
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={styles.title}>{formatDate(date)}</h3>
          <button style={styles.closeButton} onClick={onClose}>
            ✕
          </button>
        </div>

        <div style={styles.content}>
          {/* 출근 정보 */}
          <div style={styles.timeSection}>
            <div style={styles.label}>
              <span style={styles.labelIcon}>🏢</span>
              <span style={styles.labelText}>출근</span>
            </div>
            {data.checkIn ? (
              <div style={styles.timeInfo}>
                <span style={styles.time}>{data.checkIn.time}</span>
                {data.checkIn.isOutside && (
                  <span style={styles.outsideBadge}>관외</span>
                )}
              </div>
            ) : (
              <span style={styles.noData}>기록 없음</span>
            )}
          </div>

          {/* 퇴근 정보 */}
          <div style={styles.timeSection}>
            <div style={styles.label}>
              <span style={styles.labelIcon}>🏠</span>
              <span style={styles.labelText}>퇴근</span>
            </div>
            {data.checkOut ? (
              <div style={styles.timeInfo}>
                <span style={styles.time}>{data.checkOut.time}</span>
                {data.checkOut.isOutside && (
                  <span style={styles.outsideBadge}>관외</span>
                )}
              </div>
            ) : (
              <span style={styles.noData}>기록 없음</span>
            )}
          </div>
        </div>

        <div style={styles.footer}>
          <button style={styles.confirmButton} onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "420px",
    boxShadow: "0 4px 24px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
  },
  header: {
    padding: "20px 24px",
    borderBottom: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
    color: "#232323",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "24px",
    color: "#999",
    cursor: "pointer",
    padding: "0",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: "24px",
  },
  timeSection: {
    marginBottom: "20px",
    paddingBottom: "20px",
    borderBottom: "1px solid #F5F5F5",
  },
  label: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  labelIcon: {
    fontSize: "20px",
    marginRight: "8px",
  },
  labelText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#666",
  },
  timeInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  time: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#232323",
  },
  outsideBadge: {
    backgroundColor: "#FFF4E6",
    color: "#FF8A00",
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 8px",
    borderRadius: "4px",
  },
  noData: {
    fontSize: "16px",
    color: "#999",
  },
  footer: {
    padding: "16px 24px",
    borderTop: "1px solid #E5E5E5",
  },
  confirmButton: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#686769",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#fff",
    cursor: "pointer",
  },
};

export default CommuteDetailModal;
